function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg112BritishVirginIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 0.002,
    style: {
      fill: "#2E52B2"
    },
    width: 511.998,
    height: 511.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M383.998,259.709l-46.129,46.129c8.645,16.674,26.051,28.074,46.129,28.074  c20.078,0,37.484-11.4,46.129-28.074L383.998,259.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M332.056,178.086v81.622v0.001l0,0c0.001,39.759,51.942,51.941,51.942,51.941  s51.941-12.182,51.942-51.942l0,0v-0.001v-81.621H332.056z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.868,
    y: 215.184,
    style: {
      fill: "#F0F0F0"
    },
    width: 22.261,
    height: 59.358
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 383.998,
    cy: 215.184,
    r: 11.13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 346.901,
    y: 192.923,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.901,
    y: 226.314,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.901,
    y: 259.705,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.259,
    y: 192.923,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.259,
    y: 226.314,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.259,
    y: 259.705,
    style: {
      fill: "#FFDA44"
    },
    width: 14.84,
    height: 14.84
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "255.999,0 255.999,48.896 215.852,89.043 255.999,89.043 255.999,166.956 203.463,166.956   255.999,219.491 255.999,255.999 232.28,255.999 166.956,190.664 166.956,255.999 89.043,255.999 89.043,178.275 11.331,255.999   0,255.999 0,207.103 40.147,166.956 0,166.956 0,89.043 52.535,89.043 0,36.508 0,0 23.719,0 89.043,65.335 89.043,0 166.956,0   166.956,77.723 244.668,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152 104,152 104,255.999 152,255.999 152,152 255.999,152 255.999,104 152,104 152,0   104,0 104,104 0,104 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.958 0,230.82 0,255.999 0,255.999 89.041,166.958  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.137,89.041 255.999,25.179 255.999,0 255.999,0 166.958,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg112BritishVirginIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };